<template>
	
	<div class = "banner_box page_padding">
		
		<div class = "banner_left">
			
			<span class = "finger" @click = "searchOrderType(item)" :key = "index" v-for="(item,index) in orderTypeList.slice(5)">{{item.label}}</span>
			
		</div>
		<div class = "banner_grid">
			<div class = "finger" @click = "jumpToTopOrderType(systemData.topOrderType[0].value)"><img src = "../../assets/GO_01.png"/></div>
			<div  class = "finger" @click = "jumpToTopOrderType(systemData.topOrderType[2].value)"><img src = "../../assets/GO_02.png"/></div>
			<div>
				
				<login></login>
				
			</div>
			<div class = "finger"  @click = "jumpToTopOrderType(systemData.topOrderType[3].value)"><img src = "../../assets/GO_03.png"/></div>
			<div  class = "finger" @click = "jumpToTopOrderType(systemData.topOrderType[1].value)"><img src = "../../assets/GO_04.png"/></div>
			<div class = "finger"  @click = "jumpToTopOrderType(systemData.topOrderType[4].value)"><img src = "../../assets/GO_05.png"/></div>
			<div   class = "scan_box">
				
				<img style="width: 6.67vw;
	height: 6.67vw;" src = "../../assets/eq.png">
				<div>
					<div style="font-weight: 800;color:#171717;font-size: 1.04vw;">官网微信小程序</div>
					<div><span style="color: #d15e41;">扫一扫</span> 了解更多</div>
				</div>
			</div>
		</div>
	</div>
	
</template>

<script>
	import login from '../login/login.vue'
	import {getAllKind} from'../../api/cus.js'
	import {searchOrderType,searchTopOrderType} from '../../utils/index.js'
	import {mapGetters} from 'vuex'
	import common from '../../mixins/common.js'
	export default{
		mixins: [common],
		computed:{
			...mapGetters(['systemData'])
		},
		components:{
			login
		},
		data(){
			return {
				orderTypeList:[]
			}
		},
		created() {
			getAllKind().then(res=>{
				this.orderTypeList = res
			})
		},
		methods:{
			searchTopOrderType,
			searchOrderType
		}
		
		
	}
</script>

<style>
	.banner_left{
		
		width: 13.85vw;
		height: 33.38vw;
		background-color: #7e7b87;
		display: grid;
		 grid-template-columns:  6vw 6vw;
		 grid-template-rows:  repeat(auto-fill, 2.2vw);;
		 grid-column-gap: 1vw;
		padding-top: 1vw;
			justify-content: center;
	}
	.banner_left span{
		
		color: #FFFFFF;
		font-size: 1vw;
		
	}
	.banner_box{
		
		display: flex;
		justify-content: space-between;
		align-items: center;
		
	}
	
	.banner_grid div:nth-child(1){
		
		 grid-column-start: 1;
		 grid-column-end: 3; 
		
	}

	
	.banner_grid{
		
		
		 display: grid;
		 grid-template-columns:  17.71vw 17.71vw 10.21vw 16.25vw;
		 grid-template-rows: 19.06vw 13.13vw;
		  grid-row-gap: 0.72vw;
		
		grid-column-gap: 0.6vw;
		align-content: center;/*grid相对于container的布局，垂直*/
		
			height: 34.38vw;
			
		
	}
	.banner_grid img{
		
		width: 100%;
		
	}
	.banner_grid div{
		
		background-color: #FFFFFF;
		
	}
	.scan_box{
		
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		
	}
	.scan_box span:nth-child(1){
		
		color: #171717;
		font-size: 1.04vw;
		font-weight: 800;
	}
</style>
